const SKIP_FETCH_SYMBOL = Symbol('skip-fetch');
export { SKIP_FETCH_SYMBOL, };
//# sourceMappingURL=fetch-symbol.js.map